import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { 
  FiLayout, 
  FiMaximize, 
  FiImage, 
  FiSettings, 
  FiGrid, 
  FiBox, 
  FiType, 
  FiLayers, 
  FiColumns 
} from 'react-icons/fi';

const features = [
  {
    title: 'Precyzyjne rysowanie',
    desc: 'Rysuj ściany i pomieszczenia oraz swobodnie poprawiaj układ nieruchomości.Twórz dokładne układy pomieszczeń korzystając z intuicyjnych narzędzi przyciągania i siatki.',
    icon: FiLayout
  },
  {
    title: 'Drzwi i okna',
    desc: 'Dodawaj drzwi i okna, obracaj je i dopasowuj do narysowanych ścian.',
    icon: FiMaximize
  },
  {
    title: 'Twoja marka',
    desc: 'Dodaj firmowe logo. Zabezpiecz rzut przed nieautoryzowanym wykorzystaniem i buduj rozpoznawalność swojej marki.',
    icon: FiImage
  },
  {
    title: 'Eksport i publikacja',
    desc: 'Pobieraj gotowe rzuty jako obrazy PNG i wykorzystuj je w ofertach nieruchomości.',
    icon: FiSettings
  }
];

// Zestaw ikon reprezentujących poszczególne elementy biblioteki architektonicznej
const libraryIcons = [FiLayout, FiGrid, FiColumns, FiBox, FiType, FiLayers];

export default function Features() {
  return (
    <section id="features" className="py-24 bg-gray-50/30">
      <div className="max-w-8xl mx-auto px-6 sm:px-8 lg:px-12">
        
        <div className="mb-16 max-w-2xl">
          <h2 className="text-3xl sm:text-4xl text-[#1F2937] tracking-tight mb-4">
            Wszystko, czego potrzebujesz do tworzenia rzutów
          </h2>
          <p className="text-lg text-gray-500 font-normal">
            Prosty w obsłudze kreator z rozbudowanymi narzędziami do rysowania, stylizowania i udostępniania rzutów nieruchomości.
          </p>
        </div>

        {/* Attio-style Bento/Grid layout with thin borders */}
        <div className="grid md:grid-cols-2 gap-6">
          
          {/* Large Feature Card */}
          <div className="md:col-span-2 bg-white rounded-2xl border border-gray-200/80 p-8 sm:p-12 shadow-attio flex flex-col md:flex-row items-center gap-12 overflow-hidden">
            <div className="flex-1 max-w-md">
              <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-gray-100 border border-gray-200 text-[12px] font-medium text-gray-600 mb-6">
                Łatwy start
              </div>
              <h3 className="text-2xl text-[#1F2937] tracking-tight mb-4">Rysowanie dla każdego</h3>
              <p className="text-[15px] text-gray-500 leading-relaxed">
                RDzięki intuicyjnemu interfejsowi naszego kreatora użytkownicy, nawet ci bez specjalistycznej wiedzy z zakresu projektowania, mogą szybko i skutecznie stworzyć wizualizację swojego mieszkania czy domu. Funkcje "przeciągnij i upuść" oraz możliwość dodawania gotowych elementów, takich jak meble czy urządzenia, sprawiają, że proces rysowania rzutu staje się dostępny dla każdego.
              </p>
            </div>
            <div className="flex-1 w-full relative">
              <div className="aspect-[4/3] bg-gray-50/40 rounded-xl border border-gray-200/50 p-6 flex flex-wrap gap-4 items-center justify-center">
                {libraryIcons.map((Icon, i) => (
                  <div key={i} className="w-16 h-16 bg-white border border-gray-100 rounded-xl shadow-sm flex items-center justify-center text-gray-400 hover:text-gray-700 hover:shadow-md transition-all duration-300">
                    <SafeIcon icon={Icon} className="w-6 h-6" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Smaller Feature Cards */}
          {features.map((feature, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-white rounded-2xl border border-gray-200/80 p-8 shadow-attio flex flex-col"
            >
              <div className="w-10 h-10 rounded-lg border border-gray-200/80 bg-gray-50 flex items-center justify-center mb-6">
                <SafeIcon icon={feature.icon} className="w-5 h-5 text-gray-600" />
              </div>
              <h4 className="text-lg text-[#1F2937] mb-2">{feature.title}</h4>
              <p className="text-[14px] text-gray-500 leading-relaxed">
                {feature.desc}
              </p>
            </motion.div>
          ))}
          
        </div>
      </div>
    </section>
  );
}